import { Select } from "antd";
import React, { useRef } from "react";
import CustomRangePicker from "src/components/CustomRangePickerMobile/CustomRangePicker";
import SelectPackage from "src/components/Dropdown/SelectPackage";
import SelectProvider from "src/components/Dropdown/SelectProvider";

const FilterData = ({ filter, setFilter, setKeyword }) => {
  const inputSearchRef = useRef();

  const onSearch = () => {
    const keyword = inputSearchRef.current || "";
    setKeyword(keyword);
  };

  const onClearSearch = () => {
    inputSearchRef.current = "";
    setKeyword("");
  };

  return (
    <div
      style={{
        display: "flex",
        flexWrap: "wrap",
        justifyContent: "space-between",
        alignItems: "center",
        marginBottom: 16,
        minWidth: "100%",
      }}
    >
      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          gap: 12,
          maxWidth: "1000px",
        }}
      >
        {/* <SelectPackage
          style={{ width: 150 }}
          onChange={(val) => setFilter((prev) => ({ ...prev, package_id: val }))}
          listAll={true}
        />

        <SelectProvider
          style={{ width: 150 }}
          onChange={(val) =>
            setFilter((prev) => ({ ...prev, supplier_id: val }))
          }
        /> */}


        {/* Select số ngày tồn kho */}
        {/* <Select
          style={{ width: 150 }}
          placeholder="Tồn (ngày)"
          // defaultValue={20}
          allowClear
          onChange={(val) =>
            setFilter((prev) => ({
              ...prev,
              days_in_stock: val || undefined,
            }))
          }
          options={[
            { label: "10 ngày ", value: 10 },
            { label: "20 ngày", value: 20 },
            { label: "30 ngày", value: 30 },
            { label: "40 ngày", value: 40 },
            { label: "50 ngày", value: 50 },
            { label: "60 ngày", value: 60 },
          ]}
        />  */}

        <CustomRangePicker
          style={{ width: 250 }}
          format="DD/MM/YYYY"
          onChange={(dates) => {
            if (dates) {
              const [start, end] = dates;
              setFilter((prev) => ({
                ...prev,
                start_date: start
                  ? start.format("YYYY-MM-DD")
                  : undefined,
                end_date: end
                  ? end.format("YYYY-MM-DD")
                  : undefined,
              }));
            } else {
              setFilter((prev) => ({
                ...prev,
                start_date: undefined,
                end_date: undefined,
              }));
            }
          }}
        />
      </div>
    </div>
  );
};

export default FilterData;
